import { gql } from 'graphql-request'

export const Create_Book = gql`
  mutation Create_Book(
    $name: String!
    $description: String
    $image: String
    $subject: ID!
    $schoolYear: ID!
    $level: ID!
    $connectTags: [ID]
    $creator: ID!
    $createTags: [CreateTagInput]
  ) {
    createBook(
      input: {
        name: $name
        description: $description
        image: $image
        creator: { connect: $creator }
        subject: { connect: $subject }
        schoolYear: { connect: $schoolYear }
        level: { connect: $level }
        tags: { connect: $connectTags, create: $createTags }
      }
    ) {
      id
    }
  }
`

export const Update_Book = gql`
  mutation Update_Book(
    $id: ID!
    $name: String
    $description: String
    $image: String
    $subject: ID
    $schoolYear: ID
    $level: ID
    $creator: ID
    $connectSections: [ID]
    $disconnectSections: [ID]
    $connectCustomers: [ID]
    $disconnectCustomers: [ID]
    $connectTags: [ID]
    $disconnectTags: [ID]
    $createTags: [CreateTagInput]
  ) {
    updateBook(
      input: {
        id: $id
        name: $name
        description: $description
        image: $image
        creator: { connect: $creator }
        subject: { connect: $subject }
        schoolYear: { connect: $schoolYear }
        level: { connect: $level }
        sections: { connect: $connectSections, disconnect: $disconnectSections }
        customers: {
          connect: $connectCustomers
          disconnect: $disconnectCustomers
        }
        tags: {
          connect: $connectTags
          disconnect: $disconnectTags
          create: $createTags
        }
      }
    ) {
      id
    }
  }
`

export const Create_Section = gql`
  mutation Create_Section(
    $name: String!
    $description: String
    $image: String
    $subject: ID!
    $schoolYear: ID!
    $level: ID!
    $creator: ID!
    $connectTags: [ID]
    $createTags: [CreateTagInput]
  ) {
    createSection(
      input: {
        name: $name
        description: $description
        image: $image
        creator: { connect: $creator }
        subject: { connect: $subject }
        schoolYear: { connect: $schoolYear }
        level: { connect: $level }
        tags: { connect: $connectTags, create: $createTags }
      }
    ) {
      id
    }
  }
`

export const Update_Section = gql`
  mutation Update_Section(
    $id: ID!
    $description: String
    $name: String
    $image: String
    $content: String
    $teachersGuideContent: String
    $subject: ID
    $schoolYear: ID
    $level: ID
    $creator: ID
    $connectCustomers: [ID]
    $disconnectCustomers: [ID]
    $connectTags: [ID]
    $disconnectTags: [ID]
    $createTags: [CreateTagInput]
    $connectSubjectAreaTexts: [ID]
    $disconnectSubjectAreaTexts: [ID]
  ) {
    updateSection(
      input: {
        id: $id
        description: $description
        name: $name
        image: $image
        content: $content
        teachersGuideContent: $teachersGuideContent
        creator: { connect: $creator }
        subject: { connect: $subject }
        subjectAreaTexts: {
          connect: $connectSubjectAreaTexts
          disconnect: $disconnectSubjectAreaTexts
        }
        schoolYear: { connect: $schoolYear }
        level: { connect: $level }
        customers: {
          connect: $connectCustomers
          disconnect: $disconnectCustomers
        }
        tags: {
          connect: $connectTags
          disconnect: $disconnectTags
          create: $createTags
        }
      }
    ) {
      id
    }
  }
`

export const Update_Book_Section_Order = gql`
  mutation Update_Book_Section_Order($ids: [ID]) {
    updateBookSectionOrder(input: { ids: $ids }) {
      status
    }
  }
`
export const Create_School_Class = gql`
  mutation Create_School_Class($name: String!, $school: ID!, $customer: ID!) {
    createSchoolClass(
      input: {
        name: $name
        school: { connect: $school }
        customer: { connect: $customer }
      }
    ) {
      id
    }
  }
`

export const Update_School_Class = gql`
  mutation Update_School_Class($input: UpdateSchoolClassInput!) {
    updateSchoolClass(input: $input) {
      id
    }
  }
`

export const Update_Demo_School_Class = gql`
  mutation Update_Demo_School_Class($input: UpdateDemoSchoolClassInput!) {
    updateDemoSchoolClass(input: $input) {
      id
    }
  }
`

export const Update_Demo_School_Group = gql`
  mutation Update_Demo_School_Group($input: UpdateDemoSchoolGroupInput!) {
    updateDemoSchoolGroup(input: $input) {
      id
    }
  }
`

export const Delete_School_Class = gql`
  mutation Delete_School_Class($id: ID!) {
    deleteSchoolClass(input: { delete: $id }) {
      id
    }
  }
`

export const Upsert_SchoolGroup = gql`
  mutation Upsert_SchoolGroup($input: UpsertSchoolGroupInput!) {
    upsertSchoolGroup(input: $input) {
      id
    }
  }
`

export const Delete_SchoolGroup = gql`
  mutation Delete_SchoolGroup($input: DeleteSchoolGroupInput!) {
    deleteSchoolGroup(input: $input) {
      id
    }
  }
`

export const Delete_Book = gql`
  mutation Delete_Book($id: ID!) {
    deleteBook(input: { delete: $id }) {
      id
    }
  }
`

export const Update_Customer = gql`
  mutation Update_Customer(
    $id: ID!
    $connectSchoolClasses: [ID]
    $disconnectSchoolClasses: [ID]
  ) {
    updateCustomer(
      input: {
        id: $id
        schoolClasses: {
          disconnect: $disconnectSchoolClasses
          connect: $connectSchoolClasses
        }
      }
    ) {
      id
    }
  }
`

export const Unshare_Teachers_Book = gql`
  mutation Unshare_Teachers_Book($input: UnshareTeachersBookInput!) {
    unshareTeachersBook(input: $input) {
      id
    }
  }
`

export const Disconnect_Customer_SchoolClass = gql`
  mutation Disconnect_Customer_SchoolClass(
    $input: DisconnectCustomerSchoolClassInput!
  ) {
    disconnectCustomerSchoolClass(input: $input) {
      id
    }
  }
`

export const Update_Current_User = gql`
  mutation Update_Current_User(
    $id: ID!
    $currentPassword: String
    $newPassword: String
    $image: Upload
    $acceptedEula: Boolean
    $seen_popups: JSON
    $showTooltips: Boolean
  ) {
    updateCurrentUser(
      input: {
        id: $id
        currentPassword: $currentPassword
        newPassword: $newPassword
        image: $image
        acceptedEula: $acceptedEula
        seen_popups: $seen_popups
        showTooltips: $showTooltips
      }
    ) {
      id
    }
  }
`

export const Delete_Customer = gql`
  mutation Delete_Customer($id: ID!) {
    deleteCustomer(input: { delete: $id }) {
      id
    }
  }
`

export const Create_Student = gql`
  mutation Create_Student($input: CreateStudentInput!) {
    createStudent(input: $input) {
      id
      first_name
    }
  }
`

export const Create_Feedback = gql`
  mutation Create_Feedback($input: CreateFeedbackInput!) {
    createFeedback(input: $input) {
      id
    }
  }
`

export const Migrate_My_School_Class = gql`
  mutation Migrate_My_School_Class($input: MigrateMySchoolClassInput!) {
    migrateMySchoolClass(input: $input)
  }
`

export const Generate_Student_Password = gql`
  mutation Generate_Student_Password($input: GenerateStudentPasswordInput!) {
    generateStudentPassword(input: $input) {
      password
    }
  }
`

// export const Create_Exam = gql`
// mutation Create_Exam($input: CreateExamInput!) {
//   createExam(input: $input) {
//     id
//   }
// }
// `

export const Create_Exam = gql`
  mutation Create_Exam(
    $name: String!
    $type: Int!
    $image: String
    $description: String
    $additionalDescriptionOne: String
    $additionalDescriptionTwo: String
    $passingPercentage: Int
    $maxAttempts: Int
    $questionOrderType: Int
    $showAllRightAnswers: Boolean
    $answerDisplayCount: Int
    $displayType: Int
    $connectSections: [ID]
    $disconnectSections: [ID]
    $creator: ID!
  ) {
    createExam(
      input: {
        name: $name
        type: $type
        image: $image
        description: $description
        additional_description_one: $additionalDescriptionOne
        additional_description_two: $additionalDescriptionTwo
        passing_percentage: $passingPercentage
        max_attempts: $maxAttempts
        question_order_type: $questionOrderType
        show_all_right_answers: $showAllRightAnswers
        answer_display_count: $answerDisplayCount
        display_type: $displayType
        sections: { connect: $connectSections, disconnect: $disconnectSections }
        creator: { connect: $creator }
      }
    ) {
      id
    }
  }
`

export const Delete_Exam = gql`
  mutation Delete_Exam($id: ID!) {
    deleteExam(input: { delete: $id }) {
      id
    }
  }
`

export const Update_Exam_Section_Order = gql`
  mutation Update_Exam_Section_Order($ids: [ID]) {
    updateExamSectionOrder(input: { ids: $ids }) {
      status
    }
  }
`

export const Update_Exam = gql`
  mutation Update_Exam(
    $id: ID!
    $description: String
    $additionalDescriptionOne: String
    $additionalDescriptionTwo: String
    $name: String
    $image: String
    $passingPercentage: Int
    $maxAttempts: Int
    $questionOrderType: Int
    $showAllRightAnswers: Boolean
    $answerDisplayCount: Int
    $displayType: Int
    $content: String
  ) {
    updateExam(
      input: {
        id: $id
        description: $description
        additional_description_one: $additionalDescriptionOne
        additional_description_two: $additionalDescriptionTwo
        name: $name
        image: $image
        passing_percentage: $passingPercentage
        max_attempts: $maxAttempts
        question_order_type: $questionOrderType
        show_all_right_answers: $showAllRightAnswers
        answer_display_count: $answerDisplayCount
        display_type: $displayType
        content: $content
      }
    ) {
      id
    }
  }
`

export const Create_Exam_Attempt = gql`
  mutation Create_Exam_Attempt(
    $exam: ID!
    $customer: ID!
    $correctCount: Int
    $incorrectCount: Int
    $totalCount: Int
    $isPassed: Boolean
  ) {
    createExamAttempt(
      input: {
        exam: { connect: $exam }
        customer: { connect: $customer }
        correct_count: $correctCount
        incorrect_count: $incorrectCount
        total_count: $totalCount
        is_passed: $isPassed
      }
    ) {
      id
    }
  }
`

export const Update_Exam_Attempt = gql`
  mutation Update_Exam_Attempt(
    $id: ID!
    $correctCount: Int
    $incorrectCount: Int
    $isPassed: Boolean
  ) {
    updateExamAttempt(
      input: {
        id: $id
        correct_count: $correctCount
        incorrect_count: $incorrectCount
        is_passed: $isPassed
      }
    ) {
      id
    }
  }
`

export const Delete_Exam_Attempts = gql`
  mutation Delete_Exam_Attempts($ids: [ID!]!) {
    deleteExamAttempts(ids: $ids)
  }
`

export const Update_Book_Archive_Status = gql`
  mutation Update_Book_Archive_Status(
    $pivotTable: String!
    $pivotId: ID!
    $isArchived: Boolean!
  ) {
    updateBookArchiveStatus(
      pivotTable: $pivotTable
      pivotId: $pivotId
      isArchived: $isArchived
    )
  }
`
